import { ErrorCard } from "./error-card";
import { errorCardStyles as styles } from "./error-card.styles";
import { errorCardTemplate as template } from "./error-card.template";
/* eslint-disable sort-keys */
export const widgetErrorCard = ErrorCard.compose({
    baseName: "widget-error-card",
    template,
    styles,
});
